import { Const } from "@/const";

import CryptoJS from "crypto-js";

export class EncryptionHelper {

    //暗号化
    public static encrypt(text: string): string {

        var secret_passphrase = CryptoJS.enc.Utf8.parse(Const.ENCRYPTION_PASSWORD);
        var salt = CryptoJS.lib.WordArray.random(128 / 8);
        var key128Bits500Iterations = CryptoJS.PBKDF2(secret_passphrase, salt, { keySize: 128 / 8, iterations: 500 });
        var iv = CryptoJS.lib.WordArray.random(128 / 8);
        var options = { iv: iv, mode: CryptoJS.mode.CBC, padding: CryptoJS.pad.Pkcs7 };
        var message_text = CryptoJS.enc.Utf8.parse(text);
        var encrypted = CryptoJS.AES.encrypt(message_text, key128Bits500Iterations, options);
        var binary_data = CryptoJS.enc.Hex.stringify(salt);
        binary_data += (',' + CryptoJS.enc.Hex.stringify(iv));
        binary_data += (',' + encrypted);

        return binary_data;

    }

    //複合化
    public static compositeIfNeeded(text : string)
    {
        var result = text;
        try
        {
            var obj = JSON.parse(text);
        }
        catch(e)
        {
            // Jsonにパースできない場合は復号化する
            result = this.composite(text);
        }

        return result;
    }

    public static composite(text : string) {

        try
        {
            var array_rawData = text.split(',');
            var salt = CryptoJS.enc.Hex.parse(array_rawData[0]);
            var iv = CryptoJS.enc.Hex.parse(array_rawData[1]);
            var encrypted_data = CryptoJS.enc.Base64.parse(array_rawData[2]);
            var secret_passphrase = CryptoJS.enc.Utf8.parse(Const.ENCRYPTION_PASSWORD);
            var key128Bits500Iterations = CryptoJS.PBKDF2(secret_passphrase, salt, { keySize: 128 / 8, iterations: 500 });
            var options = { iv: iv, mode: CryptoJS.mode.CBC, padding: CryptoJS.pad.Pkcs7 };
            var decrypted = CryptoJS.AES.decrypt({ "ciphertext": encrypted_data }, key128Bits500Iterations, options);

            return decrypted.toString(CryptoJS.enc.Utf8);
        }
        catch
        {
            return text;
        }
        
    }

    // object -> SHA256 Hash string
    public static calcHash(obj : any) : string
    {
        var hash = CryptoJS.SHA256(JSON.stringify(obj)).toString(CryptoJS.enc.hex);
        return hash;
    }
}